// ==========================================================
// Zoom & Pan UI Floating Control Widget
// ==========================================================

import type { ViewportController } from '../engine/ViewportController';
import { sounds } from '../audio/SoundEffects';
import { i18n } from '../i18n/I18nService';

export class ZoomWidgetController {
  private viewport: ViewportController;

  private zoomInBtn: HTMLButtonElement;
  private zoomOutBtn: HTMLButtonElement;
  private resetBtn: HTMLButtonElement;
  private handBtn: HTMLButtonElement;
  private zoomLabelEl: HTMLElement;

  constructor(viewport: ViewportController) {
    this.viewport = viewport;

    this.zoomInBtn = document.getElementById('btn-zoom-in') as HTMLButtonElement;
    this.zoomOutBtn = document.getElementById('btn-zoom-out') as HTMLButtonElement;
    this.resetBtn = document.getElementById('btn-zoom-reset') as HTMLButtonElement;
    this.handBtn = document.getElementById('btn-hand-toggle') as HTMLButtonElement;
    this.zoomLabelEl = document.getElementById('zoom-level-label')!;

    this.initEvents();
    this.updateDisplay(this.viewport.getScale());
    this.updateLanguageUI();

    i18n.subscribe(() => {
      this.updateLanguageUI();
    });
  }

  private initEvents() {
    this.zoomInBtn?.addEventListener('click', () => {
      sounds.playClick();
      this.viewport.zoomAt(0.25);
    });

    this.zoomOutBtn?.addEventListener('click', () => {
      sounds.playClick();
      this.viewport.zoomAt(-0.25);
    });

    this.resetBtn?.addEventListener('click', () => {
      sounds.playClick();
      this.viewport.resetView();
    });

    this.handBtn?.addEventListener('click', () => {
      sounds.playClick();
      const isActive = this.viewport.toggleHandMode();
      this.handBtn.classList.toggle('active', isActive);
    });

    this.viewport.setCallbacks((scale) => {
      this.updateDisplay(scale);
    });
  }

  public updateDisplay(scale: number) {
    const percent = Math.round(scale * 100);
    if (this.zoomLabelEl) {
      this.zoomLabelEl.textContent = `${percent}%`;
    }
  }

  public setHandModeUI(active: boolean) {
    this.viewport.setHandMode(active);
    this.handBtn?.classList.toggle('active', active);
  }

  public updateLanguageUI() {
    const z = i18n.dict.zoom;
    if (this.zoomInBtn) this.zoomInBtn.title = z.zoomIn;
    if (this.zoomOutBtn) this.zoomOutBtn.title = z.zoomOut;
    if (this.resetBtn) this.resetBtn.title = z.reset;
    if (this.handBtn) this.handBtn.title = z.hand;
  }
}
